
import { useState } from "react";
import { RoleSelection } from "./RoleSelection";
import { DoctorLoginForm } from "./DoctorLoginForm";
import { PatientLoginForm } from "./PatientLoginForm";
import { DoctorRegisterForm } from "./DoctorRegisterForm";
import { PatientRegisterForm } from "./PatientRegisterForm";

interface AuthPageProps {
  onAuthSuccess: (user: any) => void;
}

type AuthFlow = "role-selection" | "doctor-login" | "doctor-register" | "patient-login" | "patient-register";

export function AuthPage({ onAuthSuccess }: AuthPageProps) {
  const [currentFlow, setCurrentFlow] = useState<AuthFlow>("role-selection");

  const handleRoleSelect = (role: "doctor" | "patient") => {
    if (role === "doctor") {
      setCurrentFlow("doctor-login");
    } else {
      setCurrentFlow("patient-login");
    }
  };

  const goBackToRoleSelection = () => {
    setCurrentFlow("role-selection");
  };

  if (currentFlow === "role-selection") {
    return <RoleSelection onRoleSelect={handleRoleSelect} />;
  }

  if (currentFlow === "doctor-login") {
    return (
      <DoctorLoginForm
        onLoginSuccess={onAuthSuccess}
        switchToRegister={() => setCurrentFlow("doctor-register")}
        goBack={goBackToRoleSelection}
      />
    );
  }

  if (currentFlow === "doctor-register") {
    return (
      <DoctorRegisterForm
        onRegisterSuccess={onAuthSuccess}
        switchToLogin={() => setCurrentFlow("doctor-login")}
        goBack={goBackToRoleSelection}
      />
    );
  }

  if (currentFlow === "patient-login") {
    return (
      <PatientLoginForm
        onLoginSuccess={onAuthSuccess}
        switchToRegister={() => setCurrentFlow("patient-register")}
        goBack={goBackToRoleSelection}
      />
    );
  }

  if (currentFlow === "patient-register") {
    return (
      <PatientRegisterForm
        onRegisterSuccess={onAuthSuccess}
        switchToLogin={() => setCurrentFlow("patient-login")}
        goBack={goBackToRoleSelection}
      />
    );
  }

  return <RoleSelection onRoleSelect={handleRoleSelect} />;
}
